module.exports = __webpack_public_path__ + "img/CSAT4.08336d3e.svg";